import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyBudgetContent = styled(Box, {
    name: 'BudgetContent',
})({
    padding: '2rem 4rem',
    width: '100%',
});

export default StyBudgetContent;
